<template>
  <el-tooltip :content="tooltip" placement="top" :open-delay="150">
    <span class="form-control-plaintext wr-figure">
      <span v-if="prefix">{{ prefix }}</span>{{ formatted }}
      <i class="fas fa-info-circle wr-figure-icon"></i>
    </span>
  </el-tooltip>
</template>

<script>
/**
 * A weekly report figure with an explanatory tooltip describing where the
 * number comes from. Used in the details table so every amount is explicit.
 */
export default {
  name: "weekly-report-figure",

  props: {
    value: {
      type: [Number, String],
      default: 0,
    },
    tooltip: {
      type: String,
      required: true,
    },
    prefix: {
      type: String,
      default: "",
    },
    percentage: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    formatted() {
      return this.percentage
        ? this.$formatPercentage(this.value)
        : this.$formatCurrency(this.value);
    },
  },
};
</script>

<style>
.wr-figure {
  cursor: help;
}
.wr-figure-icon {
  font-size: 0.75em;
  color: #8898aa;
  margin-left: 2px;
  vertical-align: middle;
}
</style>
